/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables =
  Types.Exact<{
    employeeId: Types.Scalars['UUID']['input'];
    order?: Types.InputMaybe<
      | ReadonlyArray<Types.InvestorFirmRelationshipSortInput>
      | Types.InvestorFirmRelationshipSortInput
    >;
    where?: Types.InputMaybe<Types.InvestorFirmRelationshipFilterInput>;
  }>;

export type CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery = {
  readonly __typename?: 'Query';
  readonly underwriterEmployees?: {
    readonly __typename?: 'UnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly salesCoverage: ReadonlyArray<{
        readonly __typename?: 'InvestorFirmRelationship';
        readonly firmId: string;
        readonly employeeId: string;
        readonly firmKey?: string | null;
        readonly firmName: string;
        readonly firmStatus: Types.RolodexRecordStatus;
        readonly location?: string | null;
        readonly relationshipType: Types.RelationshipType;
        readonly relationshipStatus: Types.RolodexRecordStatus;
        readonly lastUpdated: string;
      }>;
    }> | null;
  } | null;
};

export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables =
  Types.Exact<{
    tenantId: Types.Scalars['UUID']['input'];
    employeeId: Types.Scalars['UUID']['input'];
    order?: Types.InputMaybe<
      | ReadonlyArray<Types.InvestorFirmRelationshipSortInput>
      | Types.InvestorFirmRelationshipSortInput
    >;
    where?: Types.InputMaybe<Types.InvestorFirmRelationshipFilterInput>;
  }>;

export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery = {
  readonly __typename?: 'Query';
  readonly adminUnderwriterEmployees?: {
    readonly __typename?: 'AdminUnderwriterEmployeesCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'UnderwriterEmployee';
      readonly salesCoverage: ReadonlyArray<{
        readonly __typename?: 'InvestorFirmRelationship';
        readonly firmId: string;
        readonly employeeId: string;
        readonly firmKey?: string | null;
        readonly firmName: string;
        readonly firmStatus: Types.RolodexRecordStatus;
        readonly location?: string | null;
        readonly relationshipType: Types.RelationshipType;
        readonly relationshipStatus: Types.RolodexRecordStatus;
        readonly lastUpdated: string;
      }>;
    }> | null;
  } | null;
};

export type SalesCoverageUnderwriterEmployeeInvestorCoverageFragment = {
  readonly __typename?: 'InvestorFirmRelationship';
  readonly firmId: string;
  readonly employeeId: string;
  readonly firmKey?: string | null;
  readonly firmName: string;
  readonly firmStatus: Types.RolodexRecordStatus;
  readonly location?: string | null;
  readonly relationshipType: Types.RelationshipType;
  readonly relationshipStatus: Types.RolodexRecordStatus;
  readonly lastUpdated: string;
};

export const SalesCoverageUnderwriterEmployeeInvestorCoverageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverage',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employeeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmRelationshipSortInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InvestorFirmRelationshipFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'underwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'employeeId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesCoverage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery__
 *
 * To run a query within a React component, call `useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  > &
    (
      | {
          variables: CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageDocument, options);
}
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageDocument, options);
}
// @ts-ignore
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
  CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
>;
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
        CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery | undefined,
  CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
>;
export function useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
        CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  >(CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageDocument, options);
}
export type CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageLazyQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageLazyQuery>;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageSuspenseQueryHookResult =
  ReturnType<
    typeof useCrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageSuspenseQuery
  >;
export type CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryResult =
  Apollo.QueryResult<
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_UnderwriterEmployeeInvestorCoverageQueryVariables
  >;
export const CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverage',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employeeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'InvestorFirmRelationshipSortInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'InvestorFirmRelationshipFilterInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminUnderwriterEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'employeeId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesCoverage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalesCoverageUnderwriterEmployeeInvestorCoverage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorFirmRelationship' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'employeeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'relationshipStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery__
 *
 * To run a query within a React component, call `useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      employeeId: // value for 'employeeId'
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  > &
    (
      | {
          variables: CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageDocument, options);
}
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageDocument, options);
}
// @ts-ignore
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
>;
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery | undefined,
  CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
>;
export function useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
        CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  >(CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageDocument, options);
}
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryHookResult =
  ReturnType<typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery>;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageLazyQueryHookResult =
  ReturnType<
    typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageLazyQuery
  >;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageSuspenseQueryHookResult =
  ReturnType<
    typeof useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageSuspenseQuery
  >;
export type CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryResult =
  Apollo.QueryResult<
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQuery,
    CrmManagement_SalesCoverage_AdminUnderwriterEmployeeInvestorCoverageQueryVariables
  >;
